'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/pricing-bar-chart-tooltip.html'));
var PricingBarChartController = function PricingBarChartController(scope, rootScope, $filter, pricingBarChartDataProviderService, formatterService, BrushSelectionFilter) {
  var rmNumberFormat = $filter('rmNumberFormat');
  scope.BAR_MIN_WIDTH = 26;
  scope.MAX_BARS_AMOUNT = 20;
  scope.chartLabel = scope.datasetName === 'pos' ? 'POS' : 'O & D';
  scope.selectedMetric = {};
  scope.legendItems = {};
  scope.setLegendLabels = function (selectedMetric) {
    _.find(scope.legendItems, {
      id: 'fareChg'
    }).label = selectedMetric.legendLabel;
  };
  function isAllowToFilter(filterType) {
    return _.includes(scope.reactOnFilters, filterType);
  }
  function getFilterData() {
    return _.transform(scope.brushFilters, function (result, filter) {
      if (isAllowToFilter(filter.filterType)) {
        result[filter.filterType] = filter.getArguments();
      }
      return result;
    }, {});
  }
  scope.reloadChart = function () {
    return pricingBarChartDataProviderService.getData(scope.datasetName, scope.selectedMetric, scope.snapshotDate, scope.runNumber, getFilterData()).then(scope.handleExpandedMode).then(storeData).then(scope.renderChart).then(function () {
      var carouselIndex;
      if (scope.chartState.isExpanded) {
        carouselIndex = scope.datasetName === 'pos' ? 0 : 1;
      }
      scope.$emit('reload-carousel', carouselIndex);
    });
  };
  scope.chartFormatters = {
    xAxisTickFormatter: formatterService.identity,
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return rmNumberFormat(d, 'NUMBER_SHORT');
    },
    tooltipFormatter: function tooltipFormatter(d) {
      var tooltipModel = {
        chartLabel: scope.chartLabel,
        chartLabelValue: d.label,
        metricValue: rmNumberFormat(d.fareChange || 0),
        metricLabel: scope.selectedMetric.legendLabel,
        effectedServices: rmNumberFormat(d.numberOfEffectedServices, 'NUMBER'),
        excludedServices: rmNumberFormat(d.numberOfExcludedServices, 'NUMBER'),
        extendedServices: rmNumberFormat(d.numberOfExtendedServices, 'NUMBER'),
        recommendations: rmNumberFormat(d.numberOfEffectedServices + d.numberOfExcludedServices, 'NUMBER'),
        newServices: rmNumberFormat(d.numberOfEffectedServices - d.numberOfExtendedServices, 'NUMBER')
      };
      return tooltipTemplate(tooltipModel);
    }
  };
  function storeData(data) {
    scope.data = data;
    return data;
  }
  scope.handleExpandedMode = function (data) {
    scope.showExpandIcon = data.length > scope.MAX_BARS_AMOUNT;
    if (scope.chartState.isExpanded) {
      return data;
    }
    return _.take(data, scope.MAX_BARS_AMOUNT);
  };
  scope.createLegendItems = function () {
    return [{
      label: 'Effected Svcs',
      id: 'effSvcs',
      style: 'circle',
      fill: '#FFFFFF',
      stroke: '#707070',
      selectable: false
    }, {
      label: 'Excluded Svcs',
      id: 'exSvcs',
      style: 'circle',
      selectable: false
    }, {
      label: scope.selectedMetric.legendLabel,
      id: 'fareChg',
      fill: '#6fa8dc',
      strokeWidth: '6',
      selectable: false
    }];
  };
  scope.emitBrushFilter = function (selectedBarData) {
    var labelData = selectedBarData && selectedBarData.label ? [selectedBarData.label] : [];
    var brushFilter = new BrushSelectionFilter('summary-' + scope.datasetName, labelData);
    scope.onUpdateBrushes(brushFilter);
  };
  scope.$on('Chart:SnapshotDates:selectedSnapshotDate', function (evt, selectedSnapshotDate) {
    scope.snapshotDate = selectedSnapshotDate && selectedSnapshotDate.snapshotDate;
    scope.runNumber = selectedSnapshotDate && selectedSnapshotDate.runNumber;
    scope.legendItems = scope.createLegendItems();
    scope.reloadChart();
  });
  scope.$on('SnapshotDatesChart:changeLegend:metrics', function (evt, selectedMetric) {
    scope.selectedMetric = selectedMetric;
  });
  scope.$on('brush-filter:filterApplied', function (evt, filter) {
    if (_.includes(scope.reactOnFilters, filter.filterType)) {
      scope.emitBrushFilter(null);
      scope.reloadChart();
    }
  });
  scope.$on('brush-filter:reset', function () {
    delete scope.brushFilters['summary-' + scope.datasetName];
    scope.reloadChart();
  });
  scope.$on('PricingBarChart:chartState:changed', function () {
    scope.reloadChart();
  });
};
PricingBarChartController.$inject = ['$scope', '$rootScope', '$filter', 'PricingBarChartDataProviderService', 'FormatterService', 'BrushSelectionFilterFactory'];
module.exports = PricingBarChartController;